import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import MainBtn from "../repeats/mainBtn/MainBtn";
import Pros from "../pros/Pros";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/Footer";

import storing from "../../assets/images/storing.jpg";
import clip from "../../assets/images/magal/clip.mp4";
import privateStorage from "../../assets/images/PS/privateStorage.jpg";
import businessStorage from "../../assets/images/PS/businessStorage.jpg";
import "./Storage.css";

const Storage = () => {
  const [start, setStart] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (start && location.hash !== '#top') {
      document.querySelector(".homeTitle").scrollIntoView();
      setStart(false);
    }
  }, [location, start]);

  const servicesArr = [
    {
      header: "פרטית",
      img: privateStorage,
      link: "/privateStorage",
    },
    {
      header: "עסקית",
      img: businessStorage,
      link: "/businessStorage",
    },
  ];

  return (
    <>
      <div className="page_banner">
        <img src={storing} alt="" />
        <div className="banner_content">
          <div className="banner_title">
            <h1>אחסנה</h1>
            <p>שירות בכל רחבי הארץ באמינות ודיוק ללא פשרות</p>
          </div>
          <div className="btnDiv">
            <MainBtn text="פרטית" link="/privateStorage#top" />
            <MainBtn text="עסקית" link="/businessStorage" isLight={true} />
          </div>
        </div>
      </div>

      <Pros />

      <div className="servicesDiv">
        <h1 className="homeTitle">בחרו את סוג האחסנה שלכם</h1>
        <div className="services">
          {servicesArr.map((el, i) => {
            return (
              <Link to={el.link} key={i}>
                <div className="service">
                  <img src={el.img} alt="" />
                  <h1>{el.header}</h1>
                </div>
              </Link>
            );
          })}
        </div>
      </div>

      <div className="about blog">
        <h1 className="homeTitle">איך לבחור שירות אחסנה</h1>
        <div className="clipWrapper">
          <video
            className="clip"
            playsInline
            src={clip}
            autoPlay={true}
            muted={true}
            controls
          />
        </div>
      </div>

      <Reviews />
      <Footer isContact={true} />
    </>
  );
};

export default Storage;
